module.exports = __webpack_public_path__ + "static/media/arena.44531612.png";